/* Shopify can reload a history entry instead of keeping its document. Restore content accordions before the
   browser places the page, then its reading position. Product accordions have their own link anchor in at-product.js.
   Contact drafts stay in this tab only, including email, and a confirmed successful send clears them. */
(function () {
  if (document.body.classList.contains('template-product')) return;
  var pageKey = 'at:page:' + location.pathname + location.search;
  var draftKey = 'at:contact:' + location.pathname;
  function read(key) {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; }
  }
  function write(key, value) {
    // Storage can be unavailable in a private/restricted browser; native history still works then.
    try {
      if (value === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }
  function rows() {
    return Array.from(document.querySelectorAll('#MainContent details[id]')).filter(function (row) {
      return !row.closest('menu-drawer, modal-dialog, product-modal, facet-filters-form, [role="dialog"]');
    });
  }
  var nav = performance.getEntriesByType('navigation')[0];
  var returning = nav && nav.type === 'back_forward';
  var saved = returning && read(pageKey);
  var scrollMode;
  // Only when she had answers open: otherwise the browser's own scroll restoration (which the collection Back repaint
  // relies on) is left alone.
  if (saved && Array.isArray(saved.open) && saved.open.length && Number.isFinite(saved.y)) {
    scrollMode = history.scrollRestoration;
    history.scrollRestoration = 'manual';
    rows().forEach(function (row) {
      row.open = saved.open.includes(row.id);
      var summary = row.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', row.open);
    });
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) window.scrollTo({ top: saved.y, left: saved.x || 0, behavior: 'instant' });
    }, { once: true });
  }

  var form = document.getElementById('ContactForm');
  var sent = form && form.querySelector('.at-form-ok');
  var fields = form ? Array.from(form.querySelectorAll('input[id][name^="contact["], textarea[id], select[id]')).filter(function (field) {
    return !['hidden', 'password', 'file', 'submit', 'button'].includes(field.type);
  }) : [];
  if (sent) write(draftKey, null);
  else if (form && (returning || (nav && nav.type === 'reload')) && !form.querySelector('.at-form-error')) {
    var draft = read(draftKey);
    fields.forEach(function (field) {
      if (!draft || typeof draft[field.id] !== 'string') return;
      field.value = draft[field.id];
    });
  }
  window.addEventListener('pagehide', function () {
    write(pageKey, { open: rows().filter(function (row) { return row.open; }).map(function (row) { return row.id; }), x: scrollX, y: scrollY });
    if (form && !sent) {
      var draft = {};
      fields.forEach(function (field) { draft[field.id] = field.value; });
      write(draftKey, draft);
    }
    if (scrollMode !== undefined) history.scrollRestoration = scrollMode;
  });
})();
